import React, { useEffect, useState } from 'react'
import {Navbar, NavbarBrand, NavbarContent, NavbarItem, NavbarMenuToggle, NavbarMenu, NavbarMenuItem, Button} from "@nextui-org/react";
import logo from '../assets/Logo.png'
import logo1 from '../assets/Logo1.png'
import { CiMenuBurger, CiSearch, CiShoppingCart, CiUser } from "react-icons/ci";
import {Tabs, Tab} from "@nextui-org/react"; 
import {Badge} from "@nextui-org/badge";
import { Progress } from "@nextui-org/react";
import { useLoaderData, useLocation, useNavigate ,Link} from 'react-router-dom';
import {GrFormAdd, GrFormSubtract, GrFormEdit} from 'react-icons/gr'
import {MdOutlineCancel} from 'react-icons/md'
import { MdOutlineArrowDropDown } from "react-icons/md";
import { RiArrowDropDownFill, RiSecurePaymentFill } from "react-icons/ri";
import { IoMenu } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { getCourseList, getFacultyList, getLevelList } from '../actions/courseActions';
import { Accordion, AccordionItem} from "@nextui-org/react";
import { HiOutlineMenu } from "react-icons/hi";
import {Dropdown, DropdownTrigger, DropdownMenu, DropdownItem} from "@nextui-org/react";

const Header = () => {
    const [navbar, setNavbar] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    const dispatch = useDispatch()
    const history = useNavigate()
    const location = useLocation()

    const facultyList = useSelector(state => state.facultyList)
    const { error, loading, faculties } = facultyList

    const levelList = useSelector(state => state.levelList)
    const { error:levelListError, loading: levelListLoading, levels } = levelList

    const [selected, setSelected] = useState("/");

    // useEffect(() => {
    //   history(selected)
    // }, [selected])

    // useEffect(() => {
    //   if (location.pathname == '/'){
    //     setSelected('/')
    //   }

    // }, [location])
    
    useEffect(() => {
      if (!faculties){
        dispatch(getFacultyList())
      }
      if (!levels){
        dispatch(getLevelList())
      }
    }, [dispatch, levels, faculties])
    

    const menuItems = [
      "Home",
      "Courses",
      "About us",
      "Contact us"
    ];

  return (
    <>
      <div className='h-[50px] w-full bg-blue-950 lg:flex items-center justify-between hidden'>
        <div className='w-full h-full flex justify-between max-w-[1024px] mx-auto px-[25px] sm:px-[50px] md:px-[75px] lg:px-[25px] items-center'>
          <div className='text-white flex gap-4  '>
            <div>
              <p className='font-bold text-xs'>Address</p>
              <p className='text-xs opacity-50'>562/15, Lower Bagathale Road, Colombo 03</p>
            </div>
            <div>
              <p className='font-bold text-xs'>Email</p>
              <p className='text-xs opacity-50'>info@britishqual.lk 
              </p>
            </div>
            <div>
              <p className='font-bold text-xs'>Contact</p>
              <p className='text-xs opacity-50'>+94766778810              </p>
            </div>
          </div>
          <Button className='bg-red-600 text-white text-xs font-semibold'>
            Web mail
          </Button>
        </div>
      </div>
      <Navbar onMenuOpenChange={setIsMenuOpen} className='h-[100px] bg-white shadow-md'>
      
      <NavbarContent>
        <NavbarMenuToggle
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          className="sm:hidden"
        />
        <NavbarBrand>
          <img src={logo} alt='' className='h-[50px] w-fit object-contain' />
        </NavbarBrand>
      </NavbarContent>

      <NavbarContent className="hidden sm:flex gap-4" justify="end">
        
        <NavbarItem>
          <Link className='font-normal text-sm' to={'/'}>
            Home
          </Link>
        </NavbarItem>
        <NavbarItem isActive>
          <Dropdown>
            <DropdownTrigger>
              <Button  className='font-normal bg-transparent rounded-none  text-sm' endContent={<RiArrowDropDownFill/>}>Course</Button>
            </DropdownTrigger>
            <DropdownMenu aria-label="Static Actions">
              {
                levels?
                levels.map(i => (
                  <DropdownItem key="new">
                    <Link to={`/header/courses/faculties/${i.slug}/qualifications/credits`} className=''>
                      {i.name}
                    </Link>
                  </DropdownItem>
                ))
                :
                ''
              }
            </DropdownMenu>
          </Dropdown>
        </NavbarItem>
        <NavbarItem>
          <Link className='font-normal text-sm' to={'/dual'}>
          Dual Qualification
          </Link>
        </NavbarItem>
        <NavbarItem>
          <Link className='font-normal text-sm' to={'/contact'}>
            Contact us
          </Link>
        </NavbarItem>
        <NavbarItem>
          <Link className='font-normal text-sm' to={'/about'}>
            About us
          </Link>
        </NavbarItem>
        
      </NavbarContent>

      <NavbarMenu>
        <NavbarMenuItem key={'home'} className='pt-8 flex flex-col gap-4'>
            <Link
              to={'/'} 
              className='font-semibold'
            >
              Home
            </Link>
            <Link
              to={'/dual'} 
              className='font-semibold'
            >
              Dual Qualification
            </Link>
            <Link
              to={`/header/courses/faculties/programes/qualifications/credits`} 
              className='font-semibold'
            >
              Course
            </Link>
            <Link
              to={'/about'} 
              className='font-semibold'
            >
              About us
            </Link>
            <Link
              to={'/contact'} 
              className='font-semibold'
            >
              Contact us
            </Link>
          </NavbarMenuItem>
      </NavbarMenu>
      </Navbar>
    </>
  )
}

export default Header


// <Navbar className='py-4'>
//         <NavbarBrand>
//             <img src={logo} alt='' className='h-12'></img>
//         </NavbarBrand>
//         <NavbarContent>
//             <NavbarItem className='border-b-2 border-rose-600 hover:border-rose-500 duration-200'>
//                 <Link className='font-normal text-sm' href="#" className='text-sm text-black'>
//                     Home
//                 </Link>
//             </NavbarItem>
//             <NavbarItem>
//                 <Link className='font-normal text-sm' href="#" className='text-sm text-black'>
//                     Cart
//                 </Link>
//             </NavbarItem>
//         </NavbarContent>
//     </Navbar>